/* =====================================================================
   ContainVive · Vuelo
   El vídeo de la portada Prefab avanza y retrocede con el scroll.
   - Ordenador: vuelo-ordenador.mp4 · Móvil en vertical: vuelo-movil.mp4
   - Movimiento reducido o ahorro de datos: solo las fotos de cada escena
   - Mientras el vídeo carga se ven las fotos, así nunca hay pantalla vacía
   ===================================================================== */
(function () {
  var sec = document.getElementById('vuelo');
  if (!sec) return;

  var escenario = sec.querySelector('.vuelo-escenario');
  var video = sec.querySelector('.vuelo-video');
  var foto = sec.querySelector('.vuelo-foto');
  var textos = [].slice.call(sec.querySelectorAll('.vuelo-texto'));
  var botones = [].slice.call(sec.querySelectorAll('.vuelo-ruta button'));
  var pista = sec.querySelector('.vuelo-pista');

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ahorro = !!(navigator.connection && navigator.connection.saveData);
  var fuente = sec.querySelector('.vuelo-media source');
  // Vídeo vertical en móviles y tabletas en vertical; el resto, el horizontal (igual que la foto)
  var vertical = window.matchMedia('(orientation: portrait) and (max-width: 1024px)').matches;

  // Progreso del scroll (0–1) → segundo del vídeo
  var TRAMOS = [[0, 0], [0.17, 2.4], [0.37, 5.6], [0.55, 7.4], [0.77, 10.6], [0.93, 14.96], [1, 14.96]];
  // Cuándo se ve cada texto [entra, sale] y dónde empieza cada escena en la ruta
  var VENTANAS = [[-1, 0.14], [0.19, 0.34], [0.40, 0.52], [0.58, 0.74], [0.81, 2]];
  var LIMITES = [0, 0.17, 0.37, 0.55, 0.77, 1];
  var IR_A = [0, 0.265, 0.46, 0.66, 0.96];
  var FUNDIDO = 0.035;

  var fotos = (foto.getAttribute('data-fotos') || '').split('|');
  var fotosMovil = (foto.getAttribute('data-fotos-movil') || '').split('|');
  function ponerFoto(i) {
    if (fuente && fotosMovil[i]) fuente.srcset = fotosMovil[i];
    if (fotos[i]) foto.src = fotos[i];
  }

  var progreso = 0, objetivo = 0, actual = 0, escena = -1;
  var listo = false, cargando = false, visible = true, terminado = false, rafVivo = false;

  sec.classList.add('vuelo--activo');

  function limitar(x, a, b) { return Math.min(b, Math.max(a, x)); }
  function suave(x) { x = limitar(x, 0, 1); return x * x * (3 - 2 * x); }
  function segundo(p) {
    for (var i = 1; i < TRAMOS.length; i++) {
      if (p <= TRAMOS[i][0]) {
        var a = TRAMOS[i - 1], b = TRAMOS[i];
        return a[1] + (b[1] - a[1]) * (p - a[0]) / ((b[0] - a[0]) || 1);
      }
    }
    return TRAMOS[TRAMOS.length - 1][1];
  }
  function recorrido() { return Math.max(1, sec.offsetHeight - escenario.offsetHeight); }
  function enPantalla() { return sec.offsetParent !== null || getComputedStyle(sec).display !== 'none'; }

  function leer() {
    if (!enPantalla()) { document.body.classList.remove('vuelo-en-pantalla'); return; }
    var r = sec.getBoundingClientRect();
    progreso = limitar(-r.top / recorrido(), 0, 1);
    document.body.classList.toggle('vuelo-en-pantalla', r.top < window.innerHeight * 0.4 && r.bottom > window.innerHeight * 0.6);
    pintar();
  }

  function pintar() {
    var p = progreso;

    // Textos
    var activo = 0, mejor = -1;
    textos.forEach(function (t, i) {
      var v = VENTANAS[i];
      var o = (i === 0 ? 1 : suave((p - v[0]) / FUNDIDO)) * (i === textos.length - 1 ? 1 : suave((v[1] - p) / FUNDIDO));
      t.style.setProperty('--o', o.toFixed(3));
      t.classList.toggle('is-activo', o > 0.5);
      if (o > mejor) { mejor = o; activo = i; }
    });

    // Escena para la ruta y para las fotos
    var e = 0;
    for (var i = 0; i < LIMITES.length - 1; i++) if (p >= LIMITES[i]) e = i;
    botones.forEach(function (b, i) {
      if (i === e) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      var f = limitar((p - LIMITES[i]) / (LIMITES[i + 1] - LIMITES[i]), 0, 1);
      var punto = b.querySelector('i');
      if (punto) punto.style.setProperty('--f', f.toFixed(3));
    });
    if (e !== escena) {
      escena = e;
      if (!listo) {
        ponerFoto(e);
        var siguiente = (vertical ? fotosMovil : fotos)[e + 1];
        if (siguiente) { var precarga = new Image(); precarga.src = siguiente; }
      }
    }

    if (pista) pista.style.setProperty('--pista', (1 - limitar(p / 0.04, 0, 1)).toFixed(3));

    objetivo = segundo(p);
    if (listo && !rafVivo) { rafVivo = true; requestAnimationFrame(bucle); }

    if (!terminado && p > 0.95) {
      terminado = true;
      if (typeof cvTrack === 'function') cvTrack('vuelo_completado', { version: vertical ? 'movil' : 'ordenador' });
    }
  }

  // Lleva el vídeo hacia el segundo que toca, con un poco de inercia
  function bucle() {
    if (!listo || !visible) { rafVivo = false; return; }
    actual += (objetivo - actual) * 0.2;
    if (Math.abs(objetivo - actual) < 0.004) actual = objetivo;
    if (!video.seeking && Math.abs(video.currentTime - actual) > 0.015) {
      try { video.currentTime = actual; } catch (err) {}
    }
    if (Math.abs(objetivo - actual) < 0.004 && Math.abs(video.currentTime - actual) <= 0.015) { rafVivo = false; return; }
    requestAnimationFrame(bucle);
  }

  function cargar() {
    if (cargando || reducido || ahorro || !enPantalla()) return;
    cargando = true;
    var url = sec.getAttribute(vertical ? 'data-video-movil' : 'data-video');
    if (!url) return;
    // Se descarga entero antes de empezar: así cualquier punto del vídeo responde al momento
    fetch(url).then(function (r) { return r.ok ? r.blob() : Promise.reject(new Error(r.status)); })
      .then(function (blob) {
        video.addEventListener('loadeddata', function () {
          // iOS solo pinta fotogramas de un vídeo que se ha reproducido alguna vez
          var pr = video.play();
          if (pr && pr.then) pr.then(function () { video.pause(); }).catch(function () {});
          else video.pause();
          actual = objetivo;
          try { video.currentTime = actual; } catch (err) {}
        }, { once: true });
        video.addEventListener('seeked', function () {
          listo = true;
          sec.classList.add('vuelo--video');
          leer();
        }, { once: true });
        video.src = URL.createObjectURL(blob);
        video.load();
      })
      .catch(function () { cargando = false; });
  }

  // Botones de la ruta: van a cada escena
  botones.forEach(function (b, i) {
    b.addEventListener('click', function () {
      var y = sec.getBoundingClientRect().top + window.pageYOffset + IR_A[i] * recorrido();
      window.scrollTo({ top: Math.round(y), behavior: reducido ? 'auto' : 'smooth' });
    });
  });

  var pedido = false;
  window.addEventListener('scroll', function () {
    if (pedido) return;
    pedido = true;
    requestAnimationFrame(function () { pedido = false; leer(); });
  }, { passive: true });
  window.addEventListener('resize', leer);

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) {
      visible = entradas[0].isIntersecting;
      if (visible) { cargar(); leer(); }
    }, { rootMargin: '200px 0px' }).observe(sec);
  }

  // Al volver a la línea Prefab desde Containers
  new MutationObserver(function () { if (enPantalla()) { cargar(); leer(); } })
    .observe(document.body, { attributes: true, attributeFilter: ['data-linea'] });

  leer();
  cargar();
})();
